// src/services/zoomBooking.js
import api from './api';
import axios from 'axios';

// Get token via login
const REACT_APP_APIZOOM_URL = process.env.REACT_APP_API_ZOOM_URL;
export const loginAndGetZoomToken = async () => {
  const email = process.env.REACT_APP_API_SECRET_EMAIL;
  const password = process.env.REACT_APP_API_SECRET_PASSWORD;

  const response = await api.post(`${REACT_APP_APIZOOM_URL}/login`, { email, password });
    console.log("EMAIL:", email);
    console.log("PASSWORD:", password);
    console.log("ZOOM URL:", REACT_APP_APIZOOM_URL);

  const token = response.data.token;
  localStorage.setItem('zoom_token', token); 
  return token;
};

// Book zoom event
export const bookZoomLesson = async (slot) => {
  try {
    let zoomtoken = localStorage.getItem('zoom_token');
    if (!zoomtoken) {
      zoomtoken = await loginAndGetZoomToken();
    }

    const requestData = {
      subscription_id: 1,
      start_time: slot.start,
      end_time: slot.end,
    };

    const zoomApi = axios.create({
      baseURL: REACT_APP_APIZOOM_URL,
      headers: {
        'Authorization': `Bearer ${zoomtoken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    const response = await zoomApi.post('/integration/v1/events', requestData);
    return response.data;
  } catch (error) {
    console.error("Error booking Zoom lesson:", error);
    throw error; 
  }
};

